import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { API_URL } from '../constants';
import { IPagedResults } from '../core/interfaces';
import { BaseDataService, DataService } from '../core/services';

@Injectable()
export class LoanService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    public lastSearchedKeyword: string;

    public setLastSearchedKeyword(keyword) {
        this.lastSearchedKeyword = keyword;
    }

    public getLastSearchedKeyword() {
        return this.lastSearchedKeyword;
    }

    public getLoanList(page: number, pageSize: number = 10, filter: any): Observable<IPagedResults<any>> {
        let url = `Loan/GetAll`;
        return super.getAll<any>(url);
    }

    public getLoan(id?: number): Observable<any> {
        let url = `Loan/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public getLoanByLoanId(loanId?: string): Observable<any> {
        let url = `Loan/Get?loanId=${loanId}`;
        return super.getAll<any>(url);
    }

    public getLoanByAccountId(id: number, userId: number, siteId?: number, keyword?: string): Observable<any> {
        let keywordFilter = keyword ? `&keyword=${keyword}` : ``;
        //  
        let url = `Loan/GetAllByAccountId?id=${id}&userId=${userId}&siteId=${siteId}${keywordFilter}`;
        return super.getAll<any>(url);
    }

    public getCustomerList(): Observable<any> {
        let url = `Customer/GetAll`;
        return super.getAll<any>(url);
    }

    public getCustomerByAccountList(accountId: number, siteId: number): Observable<any> {
        let url = `Customer/GetAllByAccountId?accountId=${accountId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public getCustomer(id?: number) {
        let url = `Customer/Get?id=${id}`;
        return super.getAll<any>(url);
    }

    public isCustomerAllowedForMoreLoans(customerId: number, customerTypeId: number): any {
        let url = `Loan/IsCustomerAllowedForMoreLoans?customerId=${customerId}&customerTypeId=${customerTypeId}`;
        return super.getAll<any>(url);
    }

    public getAllMergedCustomerList(id?: number, siteId?: number): Observable<any> {
        let url = `Loan/GetAllMergedCustomer?id=${id}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public getAllMergedCustomerFilterList(id?: number, siteId?: number, keyword?: string): Observable<any> {
        let url = `Loan/GetAllMergedCustomer?id=${id}&siteId=${siteId}&keyword=${keyword}`;
        return super.getAll<any>(url).map(response => response.Data);
    }

    public getLoanTypes() {
        let url = `Loan/GetAllLoanTypes`;
        return super.getAll<any>(url);
    }

    public getLoanTypesByAccount(accountId: number) {
        let url = `Loan/GetLoanTypesByAccountId?id=${accountId}`;
        return super.getAll<any>(url);
    }

    public saveLoan(data) {
        let url = `Loan/Save`;
        return super.save<any>(url, data);
    }

    public deleteLoan(data) {
        let url = `Loan/Delete`;
        return super.save<any>(url, data);
    }

    public confirmLoan(data) {
        let url = `Loan/Confirm`;
        return super.save<any>(url, data);
    }

    public returnLoan(data) {
        let url = `Loan/Return`;
        return super.save<any>(url, data);
    }

    public sendMultipleEmails(data) {
        let url = `Loan/SendMultipleEmails`;
        return super.save<any>(url, data);
    }

    public deleteReturnedLoans(accountId: number) {
        let url = `Loan/DeleteReturnedLoans?accountId=${accountId}`;
        return super.getAll<any>(url);
    }

    public saveLoanType(data) {
        let url = `Loan/SaveLoanType`;
        return super.save<any>(url, data);
    }
    public deleteLoanType(data) {
        let url = `Loan/DeleteLoanType`;
        return super.save<any>(url, data);
    }

    public deleteCustomer(data) {
        let url = `Customer/Delete`;
        return super.save<any>(url, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/loan.service.ts